<template>

		<transition name="custom-classes-transition" enter-active-class="animate__animated animate__bounceIn" leave-active-class="animate__animated animate__bounceOutUp">

			<div
				v-if="visible"
				:class="type || 'warning'"
				class="message-wrapper frame-panel d-flex align-items-stretch none-select shadow"
			>

				<div class="content text-pre-line flex-grow-1 text-center" :class="isClose?'has-colse':''">{{ content }}</div>

				<div class="close-wrapper flex-hcvc" v-if="isClose" @click="visible = false">
					<svg-icon icon-class="close" class="close"/>
				</div>

			</div>

		</transition>

</template>
<script>

export default {
	name:'Message',
	data() {
		return {
			content:'这是一条普通的消息',
			timeOut:2000,
			visible:false,
			type:'info', //默认是info,可选success、error、warning
			isClose:false,
		};
	},
	mounted() {
		this.close();
	},
	methods:{
		close() {
			window.setTimeout(()=>{
				this.visible = false;
			}, this.timeOut);
		},
	},
};
</script>
<style lang="scss" scoped>
@import '@/styles/var.scss';

.message-wrapper {
	position:fixed;
	z-index:$message-index;
	top:5px;
	left:5px;
	width:calc(100% - 10px);
	border-radius:$radius;
	overflow:hidden;

	.content{
		padding:.75rem;
	}
	.content.has-colse{
		padding-right:2rem;
	}

	.close-wrapper{
		@extend .click-animate;
		background-color:rgba(66,66,66,.1);
		padding:.5rem;
		.close {
			color:#999;
		}
	}
	.close-wrapper:hover{
		background-color:rgba(66,66,66,.15);
		padding:.5rem;
	}

}

@media(min-width:768px) {
	.message-wrapper{
		top:2rem;
		left:calc(50% - 250px);
		width:500px;
		.content{
			padding:1rem;
		}
	}
}

.warning{
	background-color:$sys-warning!important;
	font-weight:bold;
}
.success{
	background-color:$sys-success!important;
}
.error{
	background-color:$sys-danger!important;
	font-weight:bold;
}
.warning,.success,.error{
	color:$c-light!important;
	.close-wrapper{
		.close {
			color:rgba(255,255,255,1);
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/message/Message.vue